/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_No_AddressInputs */

const th_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีนี้ไม่มีที่อยู่อีเมล จึงปิดการส่งอีเมล`)
};

const en_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account has no email address, so email is off.`)
};

const ja_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアカウントにはメールアドレスがないため、メールはオフです。`)
};

const zh_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此账户没有邮箱地址，因此邮件已关闭。`)
};

const es_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta cuenta no tiene dirección de correo, así que el correo está desactivado.`)
};

const pt_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta conta não tem endereço de e-mail, então o e-mail está desligado.`)
};

const id_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun ini tidak punya alamat email, jadi email dimatikan.`)
};

const fr_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce compte n’a pas d’adresse e-mail, donc l’e-mail est désactivé.`)
};

const tl_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang email address ang account na ito, kaya patay ang email.`)
};

const vi_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản này không có địa chỉ email, nên email đang tắt.`)
};

const ko_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 계정에는 이메일 주소가 없어 이메일이 꺼져 있습니다.`)
};

const de_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Konto hat keine E-Mail-Adresse, E-Mail ist deshalb aus.`)
};

const ru_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У этого аккаунта нет адреса электронной почты, поэтому почта выключена.`)
};

const tr_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu hesabın e-posta adresi yok, bu yüzden e-posta kapalı.`)
};

const it_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo account non ha un indirizzo email, quindi l'email è disattivata.`)
};

const pl_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To konto nie ma adresu e-mail, więc e-mail jest wyłączony.`)
};

const uk_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У цього облікового запису немає адреси електронної пошти, тож пошту вимкнено.`)
};

const hi_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस खाते का कोई ईमेल पता नहीं है, इसलिए ईमेल बंद है।`)
};

const ar_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يملك هذا الحساب بريدًا إلكترونيًا، لذا البريد موقوف.`)
};

const ms_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun ini tiada alamat e-mel, jadi e-mel dimatikan.`)
};

const bn_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই অ্যাকাউন্টের কোনও ইমেল ঠিকানা নেই, তাই ইমেল বন্ধ।`)
};

const zh_tw2_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個帳戶沒有電子郵件位址，因此郵件已關閉。`)
};

const zh_hk2_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個帳戶沒有電子郵件位址，因此郵件已關閉。`)
};

const ur_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس اکاؤنٹ کا کوئی ای میل پتہ نہیں، اس لیے ای میل بند ہے۔`)
};

const fa_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این حساب نشانی ایمیل ندارد، پس ایمیل خاموش است.`)
};

const sw_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaunti hii haina anwani ya barua pepe, kwa hivyo barua pepe imezimwa.`)
};

const nl_email_no_address = /** @type {(inputs: Email_No_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit account heeft geen e-mailadres, dus e-mail staat uit.`)
};

/**
* | output |
* | --- |
* | "This account has no email address, so email is off." |
*
* @param {Email_No_AddressInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_no_address = /** @type {((inputs?: Email_No_AddressInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_No_AddressInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_no_address(inputs)
	if (locale === "ja") return ja_email_no_address(inputs)
	if (locale === "zh") return zh_email_no_address(inputs)
	if (locale === "es") return es_email_no_address(inputs)
	if (locale === "pt") return pt_email_no_address(inputs)
	if (locale === "id") return id_email_no_address(inputs)
	if (locale === "fr") return fr_email_no_address(inputs)
	if (locale === "tl") return tl_email_no_address(inputs)
	if (locale === "vi") return vi_email_no_address(inputs)
	if (locale === "ko") return ko_email_no_address(inputs)
	if (locale === "de") return de_email_no_address(inputs)
	if (locale === "ru") return ru_email_no_address(inputs)
	if (locale === "tr") return tr_email_no_address(inputs)
	if (locale === "it") return it_email_no_address(inputs)
	if (locale === "pl") return pl_email_no_address(inputs)
	if (locale === "uk") return uk_email_no_address(inputs)
	if (locale === "hi") return hi_email_no_address(inputs)
	if (locale === "ar") return ar_email_no_address(inputs)
	if (locale === "ms") return ms_email_no_address(inputs)
	if (locale === "bn") return bn_email_no_address(inputs)
	if (locale === "zh-TW") return zh_tw2_email_no_address(inputs)
	if (locale === "zh-HK") return zh_hk2_email_no_address(inputs)
	if (locale === "ur") return ur_email_no_address(inputs)
	if (locale === "fa") return fa_email_no_address(inputs)
	if (locale === "sw") return sw_email_no_address(inputs)
	if (locale === "nl") return nl_email_no_address(inputs)
	return en_email_no_address(inputs)
});